import React from 'react';
import { PANEL_PADDING } from '../../utils/layout';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import useCountUp from '../../hooks/useCountUp';

/**
 * Dashboard stat tile: label, a large animated value, and an optional hint
 * line. Give it `to` to make the whole card a link.
 */
const StatCard = ({ icon: Icon, label, value, hint, color = 'primary.main', to }) => {
  const display = useCountUp(value);

  const content = (
    <Box sx={{ p: PANEL_PADDING, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
        {Icon && (
          <Box
            sx={{
              flexShrink: 0,
              width: 36,
              height: 36,
              borderRadius: 2.5,
              display: 'grid',
              placeItems: 'center',
              color,
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            }}
          >
            <Icon sx={{ fontSize: 20 }} />
          </Box>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, lineHeight: 1.3 }}>
          {label}
        </Typography>
      </Box>
      <Typography variant="h2" component="p" sx={{ fontSize: '2rem', lineHeight: 1.1, fontWeight: 700 }}>
        {display.toLocaleString()}
      </Typography>
      {hint && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
          {hint}
        </Typography>
      )}
    </Box>
  );

  return (
    <Card sx={{ height: '100%' }}>
      {to ? (
        <CardActionArea component={RouterLink} to={to} sx={{ height: '100%', alignItems: 'stretch' }}>
          {content}
        </CardActionArea>
      ) : (
        content
      )}
    </Card>
  );
};

export default StatCard;
